import { useEffect, useState } from "react";
import Logo from "../assets/images/Aura Logo Red 02.png";
import TranquilloLogo from "../assets/images/logo-2-scaled.png";
import { Link, useNavigate } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useModal } from "../components/ModalContext";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";

export default function HeaderTwo() {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { openModal } = useModal();
  const navigate = useNavigate();

  const navItems = [
    { name: "Home", path: "/" },
    { name: "Amenities", path: "/amenities" },
    { name: "Specifications", path: "/specifications" },
    { name: "Highlights", path: "/highlights" },
    { name: "About", path: "/about" },
    { name: "Master plan", path: "/master-plan" },
    { name: "Location", path: "/location" },
    { name: "Contact", path: "/contact" },
  ];

  const toggleMenu = () => setIsOpen(!isOpen);

const scrollToSection = (path) => {
  if (path === "/") {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
    window.history.pushState(null, "", "/");
    return;
  }

  const id = path.replace("/", "");
  const element = document.getElementById(id);

  if (element) {
    const offsetTop =
      element.getBoundingClientRect().top + window.scrollY - 100;

    window.scrollTo({ top: offsetTop, behavior: "smooth" });
    window.history.pushState(null, "", `/#${id}`);
  } else {
    navigate(`/#${id}`);
    setTimeout(() => {
      const target = document.getElementById(id);
      if (target) {
        const offsetTop =
          target.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: offsetTop, behavior: "smooth" });
        window.history.pushState(null, "", `/#${id}`);
      }
    }, 400);
  }
};


  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 w-full z-40 transition-all duration-500">
      {/* Top Navigation */}
      <div className="bg-[#c55b12] font-inter text-white flex flex-col md:flex-row justify-end items-end md:items-center px-4 py-2 xl:px-20">
        <div className="flex gap-2 text-[15px] xl:text-[18px] items-center justify-end">
          <p>Contact Us:</p>
          <Link
            to="tel:+919091999916"
            className="relative group text-[15px] xl:text-[18px] transition-colors duration-300 md:mr-6"
          >
            +91 90919 99916
            <span className="absolute bottom-0 left-1/2 w-0 h-[2px] bg-white transition-all duration-300 ease-in-out group-hover:w-full group-hover:left-0"></span>
          </Link>
        </div>
        <Link
          to="mailto:info@tranquilloprojects.com"
          className="relative group text-[15px] xl:text-[18px] transition-colors duration-300 mt-1 md:mt-0"
        >
          info@tranquilloprojects.com
          <span className="absolute bottom-0 left-1/2 w-0 h-[2px] bg-white transition-all duration-300 ease-in-out group-hover:w-full group-hover:left-0"></span>
        </Link>
      </div>

      {/* Main Nav */}
      <nav
        className={`bg-white border-gray-200 font-inter transition-all duration-500 ${
          scrolled ? "backdrop-blur-md shadow-md" : ""
        }`}
        style={{
          boxShadow: scrolled ? "0 6px 8px rgba(197, 91, 18, 0.2)" : "none",
        }}
      >
        <div className="flex items-center justify-between mx-auto max-w-screen-xl px-3 xl:px-0">
          {/* Left Logo */}
          <button
            onClick={() => {
              navigate("/");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="flex items-center space-x-3 rtl:space-x-reverse"
          >
            <img
              src={Logo}
              alt="Aura Patancheru / Aura by Tranquillo"
              style={{ height: "70px", width: "auto" }}
            />
          </button>

          {/* Desktop Nav */}
          <div className="hidden xl:flex space-x-8">
            {navItems.map((item) => (
              <div key={item.name} className="relative group">
                  <button
                    onClick={() => scrollToSection(item.path)}
                    className="text-[#5e3920] font-inter hover:text-[#a65a2e] transition-colors duration-300"
                  >
                    {item.name}
                    <span className="absolute bottom-0 left-1/2 w-0 h-[2px] bg-[#a65a2e] transition-all duration-300 ease-in-out group-hover:w-full group-hover:left-0"></span>
                  </button>
              </div>
            ))}
          </div>

          {/* Right: Logo & Mobile Toggle */}
          <div className="flex items-center space-x-4 rtl:space-x-reverse text-[#5e3920]">
            <button
              onClick={() => {
                navigate("/");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="flex items-center space-x-3 rtl:space-x-reverse"
            >
              <img
                src={TranquilloLogo}
                alt="apartments in Patancheru"
                style={{ height: "60px", width: "auto" }}
              />
            </button>
            <button
              className="xl:hidden text-[#5e3920]"
              onClick={toggleMenu}
              aria-label="Toggle Menu"
            >
              {isOpen ? (
                <CloseIcon fontSize="large" />
              ) : (
                <MenuIcon fontSize="large" />
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Offcanvas Menu */}
      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/50 z-40 xl:hidden"
            onClick={toggleMenu}
          ></div>
          <div className="fixed top-[110px] right-0 h-[calc(100%-100px)] w-[280px] max-w-[80vw] bg-white shadow-lg flex flex-col p-5 space-y-4 z-50 transition-transform duration-300 ease-in-out xl:hidden translate-x-0 border-t border-gray-200">
            {/* Mobile Nav Items */}
            <div className="flex flex-col space-y-4">
              {navItems.map((item) =>
                item.name === "Contact" ? (
                  <button
                    key={item.name}
                    onClick={() => {
                      openModal();
                      toggleMenu();
                    }}
                    className="text-[#5e3920] font-inter text-lg hover:text-[#a65a2e] transition-colors py-2 text-left"
                  >
                    {item.name}
                  </button>
                ) : (
                  <button
                    key={item.name}
                    onClick={() => {
                      scrollToSection(item.path);
                      toggleMenu();
                    }}
                    className="text-[#5e3920] font-inter text-lg hover:text-[#a65a2e] transition-colors py-2 text-left"
                  >
                    {item.name}
                  </button>
                )
              )}
            </div>

            {/* Social Icons */}
            <div className="flex justify-start space-x-3 mt-5 text-[#5e3920]">
              <a
                href="https://www.instagram.com/tranquilloprojects/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F6F4ED] rounded-lg p-2 shadow"
              >
                <InstagramIcon />
              </a>
              <a
                href="https://wa.me/918906193333?text=Hi%2C%20I%27m%20interested%20in%20your%20project"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F6F4ED] rounded-lg p-2 shadow"
              >
                <WhatsAppIcon />
              </a>
              <a
                href="https://x.com/Tranquillobuild"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F6F4ED] rounded-lg p-2 shadow"
              >
                <XIcon />
              </a>
              <a
                href="https://www.youtube.com/@tranquilloprojects2291/videos"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F6F4ED] rounded-lg p-2 shadow"
              >
                <YouTubeIcon />
              </a>
              <a
                href="https://www.linkedin.com/company/tranquillo-projects"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F6F4ED] rounded-lg p-2 shadow"
              >
                <LinkedInIcon />
              </a>
              <a
                href="https://www.facebook.com/TranquilloProjects"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F6F4ED] rounded-lg p-2 shadow"
              >
                <FacebookOutlinedIcon />
              </a>
            </div>
          </div>
        </>
      )}
    </header>
  );
}
